import { Field } from 'formik';
import React from 'react';
import { TextInput, NumberInput, Toggle } from '@carbon/react';

export function FormikTextInput(props: {
  label: string;
  name: string;
  isNumber?: boolean;
  min?: number;
  max?: number;
  allowNegative?: boolean;
  helperText?: string;
  /** Text inputs only: shown but not editable, the way Profile shows an account's email. */
  readOnly?: boolean;
}) {
  const { name, label, helperText, readOnly } = props;
  return (
    <Field name={name}>
      {({ field, meta }) => {
        if (props.isNumber) {
          return (
            <NumberInput
              id={name}
              min={props.allowNegative ? undefined : props.min || 0}
              max={props.max}
              label={label}
              helperText={helperText}
              invalid={!!(meta.touched && meta.error)}
              invalidText={meta.error}
              {...field}
            />
          );
        }
        return (
          <TextInput
            id={name}
            labelText={label}
            helperText={helperText}
            readOnly={readOnly}
            invalid={!!(meta.touched && meta.error)}
            invalidText={meta.error}
            {...field}
          />
        );
      }}
    </Field>
  );
}

export function FormikToggle(props: { label: string; name: string; disabled?: boolean }) {
  const { name, label, disabled } = props;
  return (
    <Field name={name}>
      {({ field, form }) => (
        <Toggle
          id={name}
          labelText={label}
          toggled={!!field.value}
          disabled={disabled}
          onToggle={(checked) => form.setFieldValue(name, checked)}
        />
      )}
    </Field>
  );
}
